import { buildSlice, CommonState } from '~libs/reduxUtils';

import { ClientService, SahClientServicesGrouped } from '~support-at-home/models';

import { getAll, getGrouped, typePrefix, uploadFile } from '~support-at-home/actions/clientServices';

interface State extends CommonState<ClientService> {
  grouped: SahClientServicesGrouped[];
}

const initialState: State = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  uploadError: null,
  rows: [],
  grouped: [],
};

const slice = buildSlice<State, ClientService>(typePrefix, initialState, {
  extraReducers(builder) {
    builder.addCase(getGrouped.fulfilled, (state, action) => {
      state.loading = 'fulfilled';
      state.grouped = action.payload.data;
    });
    builder.addCase(uploadFile.rejected, (state, action) => {
      state.uploadError = action.payload as string;
    });
  },
  customActions: {
    clear(state) {
      state.rows = [];
    },
    clearError(state) {
      state.uploadError = null;
      state.error = null;
    },
  },
  commonConfig: { getAll },
});

export const { clear, clearError } = slice.actions;
export default slice.reducer;
